import { useTheme } from '@mui/material';

import { Button, Icons, HexIcon, Typography, Stack } from '@cast/design-system';

import { useAbility } from '@cast/shared-ability-data-access';
import { useEnableCastFeaturesDialog } from 'hooks/dialogs/cluster/useEnableCastFeaturesDialog';

import { useSecurityDemoVideoDialog } from '../_hooks/useSecurityDemoVideoDialog';

type EnableSecurityBannerProps = {
  onDismiss: () => void;
};

export const EnableSecurityBanner = ({
  onDismiss,
}: EnableSecurityBannerProps) => {
  const canEdit = useAbility().can('update', 'Clusters');
  const { openSecurityDemoVideoDialog } = useSecurityDemoVideoDialog();
  const { openEnableCastFeaturesDialog } = useEnableCastFeaturesDialog();
  const { palette } = useTheme();

  return (
    <Stack
      alignItems="center"
      maxWidth={670}
      margin="auto"
      mt={-8}
      mb={56}
      data-testid="enable-security-overlay"
    >
      <HexIcon
        size={72}
        icon={
          <Icons.CastSecurity weight="light" color={palette.indigo['400']} />
        }
        hexColor="indigo.200"
      />
      <Typography variant="h5" mb={8}>
        Unlock Security!
      </Typography>
      <Typography variant="P14R" color="textSecondary" mb={24}>
        Ensure container security with our Kubernetes Security Posture
        Management. Automatically assess, detect threats, remediate, and stay
        compliant. Watch the{' '}
        <Button
          variant="text"
          sx={{ fontSize: 'inherit' }}
          onClick={() => openSecurityDemoVideoDialog()}
        >
          video to learn more
        </Button>
        .
      </Typography>
      <Stack direction="row" gap={16}>
        <Button
          variant="secondary"
          size="md"
          endIcon={<Icons.CaretDoubleDown />}
          onClick={onDismiss}
          testId="explore-demo-button"
        >
          Explore demo
        </Button>
        <Button
          disabled={!canEdit}
          size="md"
          onClick={() => openEnableCastFeaturesDialog()}
          testId="enable-security-button"
        >
          Enable security
        </Button>
      </Stack>
    </Stack>
  );
};
